import Vue from "vue";

export class Concentrador {
    static create() {
        return {
            ssh: {
                host: null,
                username: null,
                password: null,
                readyTimeout: 5000,
                algorithms: {
                    serverHostKey: ["ssh-rsa", "ssh-dss"]
                }
            },
            interface: null,
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("concentrador/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("concentrador/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static sendComandoAll(data) {
        return new Promise((resolve, reject) => {
            Vue.http
                .post("concentradores/comandos-all", data)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("concentradores")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("concentradores", data);
            } else {
                promisse = Vue.http.post("concentradores", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
